import { render, staticRenderFns } from "./PayByCard.vue?vue&type=template&id=00d40e6a&scoped=true"
import script from "./PayByCard.vue?vue&type=script&lang=ts"
export * from "./PayByCard.vue?vue&type=script&lang=ts"
import style0 from "./PayByCard.vue?vue&type=style&index=0&id=00d40e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d40e6a",
  null
  
)

export default component.exports